import {Action} from 'platform/components';
import {Box} from 'platform/foundation';

import {useGetTireIdsQuery} from '@dms/api/core';
import i18n from '@dms/i18n';
import {tiresInventoryRoutes} from '@dms/routes';
import {Section, SectionTab, usePermissions} from '@dms/shared';

import {buildArray, composePath, isNotNilOrEmpty} from 'shared/web';

import {TiresDG} from './TiresDG';
import {TireSets} from './TireSets';

interface TiresProps {
  vehicleId: string;
}

export function Tires(props: TiresProps) {
  const [canReadPneuhotel] = usePermissions({permissionKeys: ['pneuhotelRead']});

  const tabs = buildArray<SectionTab>([])
    .when(canReadPneuhotel, {
      queryId: 'tireSets',
      content: <TireSets vehicleId={props.vehicleId} />,
      title: i18n.t('page.tiresInventory.labels.tireSets'),
    })
    .when(canReadPneuhotel, {
      queryId: 'tires',
      content: <TiresDG vehicleId={props.vehicleId} />,
      title: i18n.t('page.tiresInventory.labels.tierList'),
    });

  const tireOrderIdsQuery = useGetTireIdsQuery({
    vehicleId: props.vehicleId,
  });

  const firstTireOrder = tireOrderIdsQuery.data?.[0];
  const hasTireOrder = isNotNilOrEmpty(firstTireOrder);

  const tireActions = buildArray<Action>()
    .whenNot(canReadPneuhotel, {
      type: 'button',
      variant: 'link',
      leftIcon: 'action/open_in_new',
      title: i18n.t('page.tiresInventory.labels.tiresInventory'),
      onClick: () => window.open(tiresInventoryRoutes.overview, '_blank'),
    })
    .when(canReadPneuhotel && hasTireOrder, {
      type: 'button',
      variant: 'link',
      leftIcon: 'action/open_in_new',
      title: i18n.t('page.tiresInventory.labels.tiresInventory'),
      onClick: () => {
        window.open(
          composePath(tiresInventoryRoutes.tireOrderDetail, {
            params: {id: tireOrderIdsQuery.data?.[0]?.orderId},
            isSearchParamsPreserved: false,
          }),
          '_blank'
        );
      },
    });

  return (
    <Box width="100%" padding={0}>
      <Section tabs={tabs} queryParameterName="tireTab" padding={0} actions={tireActions} />
    </Box>
  );
}
